<template>
  <div class="query">
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        v-model="currentDate"
         type="date"
         title="选择时间"
         :min-date="minDate"
         :max-date="maxDate"
         :formatter="formatter"
         @confirm='confirmPicker'
         @cancel="canceldatetime"
      />
    </van-popup>
    <!-- <van-popup  /> -->

    <!-- 日期选择 -->
    <div class="choosetime font28 c000 mt10">
      <div class="jiantoubox" @click="openDatetime">
        <div>{{timeValue}}</div>
        <div class="jiantoux"></div>
      </div>
    </div>
    <!-- 日期选择end -->
    <van-empty v-if="orderInfo.length<='0'" image="search" description="暂无订单" />
    <Orderlist v-else :orderInfo="orderInfo" :total="total" :formData="formData" :timeValue="timeValue"></Orderlist>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from '../components/tabbar.vue'
import Orderlist from '../components/orderlist.vue'
import { Toast } from 'vant'
export default{
  name: 'query', // 查询页面
  components: {
    'Tabbar': Tabbar,
    'Orderlist': Orderlist
  },
  data () {
    return {
      show: false,
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      timeValue: '', // 要查询的时间
      orderInfo: [], // 订单数据
      // 列表查询参数
      formData: {
        pageNum: 1,
        pageSize: 10,
        date: ''
      },
      total: '',
      flag: true

    }
  },
  created () {
    var time = new Date()
    this.confirmPicker(time, this.formData)
    // this.getIndexInfo(time);
  },
  methods: {
    // 请求数据
    getIndexInfo (time, formData) {
      var that = this
      if (!that.flag) { return }
      if (!time) {
        time = that.timeValue
      }
      // console.log(formData)
      formData.date = time
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      that.flag = false
      this.$api.HZrequest('/we-chat/gzh/get-washer-orders-in-date', 'GET', formData).then((res) => {
        // that.hasMore = res.hasMore
        if (res.rows.length > 0) {
          that.orderInfo = that.orderInfo.concat(res.rows)
          that.total = res.total
        }
        setTimeout(function () {
          Toast.clear()
          that.flag = true
        }, 500)
      })
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    openDatetime () {
      this.show = true
    },
    // 确认选择的时间
    confirmPicker (val) {
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      this.className = 'timeClass'
      this.timeValue = `${year}-${month}-${day}`
      this.show = false
      this.hasMore = true
      this.orderInfo = []
      this.getIndexInfo(this.timeValue, this.formData)
    },

    // 取消时间选择
    canceldatetime () {
      this.show = false
    }

  }

}
</script>

<style>
  .query{padding-top: 0.1rem;}
  .choosetime{width: 100%;box-sizing: border-box;;padding: 0 0.32rem;display: flex;justify-content: flex-end;align-items: center;}
  .jiantoubox{display: flex;align-items: center;}
  .jiantoux{width: 0.12rem;height: 0.12rem;border-bottom: 0.02rem solid #333;border-right: 0.02rem solid #333;transform: rotate(45deg);margin-left: 0.10rem;margin-top: -0.12rem}
</style>



// WEBPACK FOOTER //
// src/view/query.vue